export enum SignInvoiceStatus {
  APPROVED = 'APPROVED',
  FAILED = 'FAILED',
  REJECTED = 'REJECTED',
  UNDEFINED = 'UNDEFINED',
  WAITING = 'WAITING'
}
